define(["require", "exports", "vue", "../../html-templates/contact-person-component-vue-template.html"], function (require, exports, vue_1, template) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ContactPersonComponent = (function () {
        function ContactPersonComponent() {
            vue_1.default.component('contact-person', {
                template: template,
                props: {
                    value: {
                        type: Object,
                        default: function () {
                            return {
                                model: {
                                    FirstName: "",
                                    LastName: "",
                                    MiddleName: "",
                                    MailAddress: "",
                                    Phone: "",
                                    Mobile: "",
                                    Fax: "",
                                    Department: ""
                                }
                            };
                        }
                    },
                    index: {
                        type: Number,
                        default: function () {
                            return null;
                        }
                    }
                },
                watch: {
                    value: {
                        handler: function () {
                            this.model = this.value;
                        },
                        deep: true
                    }
                },
                data: function () {
                    return {
                        model: this.value
                    };
                },
                methods: {
                    update: function (event) {
                        console.log(this.model);
                        this.$emit('input', this.model);
                    }
                },
                inject: ['$validator']
            });
        }
        return ContactPersonComponent;
    }());
    exports.ContactPersonComponent = ContactPersonComponent;
});
//# sourceMappingURL=ContactPersonComponent.js.map


//////////////////
// WEBPACK FOOTER
// ./wwwroot/js/Components/ContactPersonComponent.js
// module id = 381
// module chunks = 0